<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        lg="6"
      >
        <food-chart-card />
      </v-col>

      <v-col
        cols="12"
        lg="6"
      >
      <!-- WEIGHT CHART -->
        <weight-chart-card />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import weightChartCard from '@/views/dashboard/component/WeightChartCard'
  import foodChartCard from '@/views/dashboard/component/FoodChartCard'

  export default {
    components: {
      weightChartCard,
      foodChartCard
    },
    name: 'Dashboard',

    data () {
      return {}
    },

    methods: {
    },
    computed: {
    },
    mounted: function() {
    }
  }
</script>
<style >
</style>